// API Configuration
export const API_BASE_URL = 'https://api.fixupnow.in/';
// export const API_BASE_URL = 'http://localhost:6006/';

// App Configuration
export const APP_NAME = 'Friends Manager Portal';
export const APP_VERSION = '1.0.0';

// Theme Colors
export const colors = {
  primary: '#006994',      // BackLoginColor from mobile app
  secondary: '#00acc1',
  white: '#ffffff',
  black: '#000000',
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#2196f3',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_ID: 'userId',
  TOKEN: 'token',
  USER_DATA: 'userData',
  CITY: 'city',
};

// User Types
export const USER_TYPES = {
  MANAGER: 'manager',
  ADMIN: 'admin',
  PARTNER: 'partner',
  CUSTOMER: 'customer',
};

// User Status
export const USER_STATUS = {
  VERIFIED: 'verified',
  UNVERIFIED: 'unverified',
  REJECTED: 'rejected',
  PENDING: 'pending',
};

// Service Request Status
export const SERVICE_STATUS = {
  PENDING: 'pending',
  UPCOMING: 'upcoming',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};
